import React from 'react';
import css from './RadioInput.module.css';

interface RadioInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    extraClassName?: string;
}

const RadioInput: React.FC<RadioInputProps> = ({
    label,
    disabled = false,
    checked,
    value,
    extraClassName,
    ...props
}) => {
    const handleCircleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (!disabled) {
            const event = {
                target: { value, checked: !checked } as HTMLInputElement,
            } as React.ChangeEvent<HTMLInputElement>;
            props.onChange?.(event);
        }
    };

    return (
        <label
            className={`${css.customRadio} ${disabled ? css.disabled : ''} ${extraClassName ? extraClassName : ''}`}
        >
            <input
                type="radio"
                checked={checked}
                value={value}
                disabled={disabled}
                onFocus={e => e.target.blur()}
                tabIndex={-1}
                className={css.input}
                {...props}
            />
            <span className={css.circle} onClick={handleCircleClick}></span>
            {label && <span className={css.label}>{label}</span>}
        </label>
    );
};

export default React.memo(RadioInput);
